// Local-only win counter. Online wins are tracked server-side on the account.
const KEY = 'games:localWins';

export function getLocalWins(): number {
  try {
    const raw = localStorage.getItem(KEY);
    const n = raw ? Number.parseInt(raw, 10) : 0;
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function incrementLocalWins(): number {
  const next = getLocalWins() + 1;
  try {
    localStorage.setItem(KEY, String(next));
  } catch {}
  return next;
}
